import Client from '../HttpClient';

const baseUrl = '/api/push';

const recordList = (pageNo = 1, pageSize = 10000) => {
	return Client.get(`${baseUrl}/record-list`, {
		pageNo,
		pageSize,
	});
};

const repush = () => {
	return Client.post(`${baseUrl}/re-push`);
};

export default { recordList, repush };
